// Shim: Bridges legacy UserSessionContext imports to actual context providers
import { useWorkspace } from '@/contexts/ContextoWorkspace';
import { useAuth } from '@/contexts/ContextoAuth';

export function useCurrentEstablecimientoId(): string | null {
  const { establecimientoId } = useWorkspace();
  return establecimientoId;
}

export function useCurrentEstablecimiento() {
  const { currentEstablecimiento } = useWorkspace();
  return currentEstablecimiento;
}

export function useCurrentCompanyId(): string | null {
  const { empresaId } = useWorkspace();
  return empresaId;
}

export function useCurrentCompany() {
  const { currentEmpresa } = useWorkspace();
  return currentEmpresa;
}

export function useUserSession() {
  const { user } = useAuth();
  const { establecimientoId, currentEstablecimiento, establecimientos } = useWorkspace();
  const { empresaId: currentCompanyId } = useWorkspace();
  const session = user
    ? {
        userName: `${(user as any)['nombre'] ?? ''} ${(user as any)['apellido'] ?? ''}`.trim() || ((user as any)['email'] ?? ''),
        userId: String((user as any)['id'] ?? ''),
        email: (user as any)['email'] ?? '',
        currentCompanyId,
        currentEstablecimientoId: establecimientoId,
        currentEstablecimiento,
        availableEstablecimientos: establecimientos,
      }
    : null;
  return { session };
}
